import React, { useEffect, useState } from 'react'
import { PatternFormat } from 'react-number-format';
import { useDispatch } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import { makePath } from '../helpers/path'
import AuthService from '../services/auth'
import { setUser } from '../store/user/user.actions'
import { Button, Checkbox, Flex, Form, Input, message, Typography } from 'antd'
import { useSelector } from 'react-redux'
import { ApplicationState } from '../store'
import ModalSupport from '../components/Home/ModalSupport';
import ForgotPassword from '../components/Login/ForgotPassword';
import { Space } from 'antd';
import type { TabsProps } from 'antd';
import PatternNumber from '../helpers/PatternNumber';
import { prefixAllow } from '../helpers/prefixAllow';

const { Text } = Typography

const Login = () => {
	const [messageApi, contextHolder] = message.useMessage();
	const dispatch = useDispatch()
	const history = useHistory()
	const [form] = Form.useForm();
	const [isSubmitting, setSubmitting] = useState<boolean>(false)
	const prefixState = useSelector((state: ApplicationState) => state.prefix)
	const prefix: any = prefixState.info
	const allowedPrefixes = [...prefixAllow, 'LUKA365']
	const isAllowedPrefix = allowedPrefixes.includes(prefix.prefix)

	const [showMenuSupportLine, setShowMenuSupportLine] = useState<boolean>(false)

	const [openSupport, setOpenSupport] = useState<boolean>(false)
	const handleModalSupport = () => setOpenSupport(!openSupport)

	const [forgotPassword, setForgotPassword] = useState<boolean>(false)
	const handleForgotPassword = () => setForgotPassword(!forgotPassword)

	const [showMenuSupport, setShowMenuSupport] = useState<boolean>(true)
	const isRegister = !prefixState?.info?.functions.hasOwnProperty("offRegister") || !prefixState?.info?.functions['offRegister'];

	const handleSubmit = async () => {
		form.validateFields()
			.then(async (values: any) => {
				setSubmitting(true)
				if (values.remember) {
					const encryptedData = btoa(JSON.stringify({
						'username': values.phone,
						'password': values.password,
						'rememberMe': values.remember
					}));
					localStorage.setItem('rememberedUser', encryptedData);
				} else {
					localStorage.removeItem('rememberedUser');
				}
				delete values.remember
				try {
					const res: any = await AuthService.login({
						phone: values.phone.replace(/-/g, ''),
						password: values.password,
					})

					if (res.move) {
						history.push(makePath('/move-web'))
					} else {
						dispatch(setUser(res))
						if ((prefix?.game)?.toUpperCase() === "AMBKING" ||
							(prefix?.game === "betflix" && prefix?.functions.betflixOnListgame) ||
							(prefix?.game === "pgoon" && prefix?.functions.pgoonOnListgame)
						) {
							history.push(makePath('/launch-game'))
						} else {
							history.push(makePath('/wallet'))
						}
					}
				} catch ({ message }: any) {
					// toast.error(message as string)
					messageApi.open({
						type: 'error',
						content: message as string,
					});
					setSubmitting(false)
				} finally {
					setSubmitting(false)
				}
			}).catch();
	}

	const handleTabs = (key: string) => {
		if (key === "register") {
			history.push(makePath('/register'))
		}
	};

	const itemTabs: TabsProps['items'] = [
		{
			key: 'login',
			label: 'เข้าสู่ระบบ',
		},
		{
			key: 'register',
			label: 'สมัครสมาชิก',
		},
	];

	const [isFocused, setIsFocused] = useState(false);
	const [value, setValue] = useState('');

	const handleFocus = () => setIsFocused(true);
	const handleBlur = () => {
		if (!value) setIsFocused(false);
	};

	useEffect(() => {
		if (prefixState.info) {
			const isNullishSocialMediaLine = prefixState.info?.socialMedia ?
				(Object.keys(prefixState.info?.socialMedia).find((item: any) => item === "line") && prefixState.info?.socialMedia.line !== "" ? true : false)
				: false;
			setShowMenuSupportLine(isNullishSocialMediaLine)


			const isNullishSocialMedia = prefixState.info?.socialMedia ? Object.values(prefixState.info?.socialMedia).every(value => {
				if (value === "") {
					return true;
				}
				return false;
			}) : true;
			setShowMenuSupport(isNullishSocialMedia)
		}
	}, [prefixState])

	useEffect(() => {
		if (form) {
			form.setFieldsValue({
				'phone': '',
				'password': '',
				'remember': false
			})
			// const rememberedUser = Cookies.get('rememberedUser');
			const rememberedUser = localStorage.getItem('rememberedUser');
			if (rememberedUser !== undefined && rememberedUser !== null) {
				const decodedString = atob(rememberedUser as string);
				if (decodedString) {
					const { username, password, rememberMe } = JSON.parse(decodedString);
					// setRememberMe(rememberMe);
					if (form) {
						form.setFieldsValue({
							'phone': username,
							'password': password,
							'remember': rememberMe
						})
					}
				}
			}
		}
	}, [form])

	return (
		<>
			{contextHolder}
			{isRegister &&
				<div className="tab-auth-container">
					<div className="tab-auth-menu active" onClick={() => handleTabs('login')}>เข้าสู่ระบบ</div>
					<div className="tab-auth-menu" onClick={() => handleTabs('register')}>สมัครสมาชิก</div>
				</div>
			}

			<Form
				form={form}
				name="truewalletqrdialogForm"
				layout="vertical"
				hideRequiredMark
			>
				<Form.Item
					name="phone"
					rules={[{ required: true, message: 'กรุณากรอกเบอร์โทรศัพท์' }]}
					style={{ marginBottom: 12 }}
				>
					<PatternFormat
						className="ant-input"
						format="###-###-####"
						mask="_"
						type="tel"
						placeholder="เบอร์โทรศัพท์"
					/>
				</Form.Item>
				{isAllowedPrefix ?
					<Form.Item
						name="password"
						rules={[
							{ required: true, message: 'กรุณากรอกรหัสผ่าน' },
							{ pattern: PatternNumber, message: 'กรุณากรอกเป็นตัวเลขเท่านั้น' }
						]}
						style={{ marginBottom: 8 }}
					>
						<Input.Password
							placeholder="รหัสผ่าน" inputMode='numeric' maxLength={6} minLength={6}
						/>
					</Form.Item>
					:
					<Form.Item
						name="password"
						rules={[{ required: true, message: 'กรุณากรอกรหัสผ่าน' }]}
						style={{ marginBottom: 8 }}
					>
						<Input.Password placeholder="รหัสผ่าน" inputMode='numeric' />
					</Form.Item>
				}
				<Flex justify='space-between' align='center'>
					<Form.Item
						name="remember"
						valuePropName="checked"
						style={{ marginBottom: 8 }}
					>
						<Checkbox>จดจำฉัน</Checkbox>
					</Form.Item>
					<Button type="link" onClick={handleForgotPassword}>
						<span style={{ color: '#fff', textDecoration: 'underline' }}>ลืมรหัสผ่าน?</span>
					</Button>
				</Flex>
				<Button
					type="primary"
					htmlType="submit"
					loading={isSubmitting}
					onClick={handleSubmit}
					style={{ marginBottom: 16 }}
					block
				>
					เข้าสู่ระบบ
				</Button>
				{prefix?.functions?.lineLogin &&
					<Link to={makePath('/login-line')}>
						<Button className="ant-btn-dark" style={{ marginBottom: 16 }} block>
							<Space size={12}>
								<img src="/icons/new/line-logo.svg" alt="line logo" style={{ width: 22, paddingTop: 1 }} />
								<div>
									<span>เข้าสู่ระบบด้วย LINE</span>
								</div>
							</Space>
						</Button>
					</Link>
				}
			</Form>

			{!showMenuSupport && (
				<Link to={"#"} onClick={handleModalSupport}>
					<div style={{ textAlign: 'center', padding: '8px 0 4px' }}>
						<Text>หากมีข้อสงสัยติดต่อ <span style={{ color: '#fff', textDecoration: 'underline' }}>ฝ่ายบริการลูกค้า</span></Text>
					</div>
				</Link>
			)}
			{prefix?.lineLink && showMenuSupport && (
				<Link to={{ pathname: prefix.lineLink }} target="_blank">
					<div style={{ textAlign: 'center', padding: '8px 0 4px' }}>
						<Text>หากมีข้อสงสัยติดต่อ <span style={{ color: '#fff', textDecoration: 'underline' }}>ฝ่ายบริการลูกค้า</span></Text>
					</div>
				</Link>
			)}

			<ModalSupport isOpen={openSupport} onClose={() => setOpenSupport(false)} />
			<ForgotPassword isOpen={forgotPassword} onClose={() => setForgotPassword(false)} />
		</>
	)
}

export default Login
